// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportConfigurationContent.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ReportConfigurationContent component
 */

import React, { Component } from 'react';
import classnames from 'classnames';
import connect from 'share/enhancers/Izenda.Connect';
import actions from './Izenda.ReportConfigurationAction';
import ReportConfigurationRecurrent from './Izenda.ReportConfigurationRecurrent';
import Panel from 'share/components/controls/Izenda.Panel';
import Input from 'share/components/controls/Izenda.Input';
import Button from 'share/components/controls/Izenda.Button';
import NumericInput from 'share/components/controls/Izenda.NumericInput';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import GlobalAndLocalNames from './Izenda.GlobalAndLocalNames';
import DefaultColorTheme from './Izenda.DefaultColorTheme';
import { isNil } from 'lodash/fp';

const VersionHeaderPanel = connect()(props => {
  const localization = props.localization;

  return (
    <div onClick={props.collapseToggle}>
      <div className="u_inlineBlock u_marginRight">
        <i className="icon-toggle-triangle" />
        <strong>{localization.getText('SYSTEM_CONFIGURATION_REPORT_LABEL_VERSION')}</strong>
      </div>
      <Button
        onClick={props.onClearArchivedVersion}
        disabled={!props.store.reportConfiguration.enforceVersionHistory}
        label={localization.getText('SYSTEM_CONFIGURATION_REPORT_CLEAR_ARCHIVED_VERSIONS_NOW')}
      />
    </div>
  );
});

const DefaultImageHeaderPanel = connect()(props => {
  const localization = props.localization;

  return (
    <div onClick={props.collapseToggle}>
      <i className="icon-toggle-triangle" />
      <strong>{localization.getText('SYSTEM_CONFIGURATION_REPORT_DEFAULT_HEADER_IMAGE')}</strong>
    </div>
  );
});

const ReportVersionStorage = connect()(props => {
  const {
    store: { reportConfiguration: model },
    localization
  } = props;

  return (
    <div>
      <hr />
      <p>{localization.getText('SYSTEM_CONFIGURATION_REPORT_LABEL_VERSION_STORAGE')}</p>

      <div className="u_marginLeft input-group">
        <span>{localization.getText('SYSTEM_CONFIGURATION_REPORT_ARCHIVE_VERSION_TO_KEEPS')}</span>

        <NumericInput
          className="u_marginLeftRight u_inlineBlock"
          min={0}
          max={20}
          value={model.numOfArchivedVersionToKeep}
          onBlur={props.setNumOfArchivedVersionToKeep.bind(props, model.numOfArchivedVersionToKeep)}
          onChange={model.setValueByKey.bind(model, 'numOfArchivedVersionToKeep')}
        />

        <a onClick={model.resetNumOfArchivedVersionToKeep.bind(model)} title="Reset value">
          <span className="icon-ccw resetButton" />
        </a>
      </div>

      <GridLayout className="u_marginLeft">
        <GridLayout.Row>
          <GridLayout.Col cols="3">
            <div className="checkbox">
              <label>
                <Input
                  type="checkbox"
                  checked={model.removeArchivedVersions}
                  onChange={props.onCheckRemoveArchivedVersions}
                />
                {localization.getText('SYSTEM_CONFIGURATION_REPORT_REMOVE_ARCHIVED_VERSIONS')}
              </label>
            </div>
          </GridLayout.Col>

          {model.removeArchivedVersions && <ReportConfigurationRecurrent {...props} />}
        </GridLayout.Row>
      </GridLayout>
    </div>
  );
});

@connect(actions)
export default class ReportConfigurationContent extends Component {
  componentDidMount() {
    this.props.store.init();
  }

  componentWillUnmount() {
    this.props.store.destroy();
  }

  render() {
    const props = this.props;
    const {
      store,
      store: { reportConfiguration: model },
      localization
    } = props;
    const header = {
      className: 'u-bgGray',
      component: VersionHeaderPanel,
      onClearArchivedVersion: props.onClearArchivedVersion,
      store: store
    };
    const defaultImageHeader = {
      className: 'u-bgGray',
      component: DefaultImageHeaderPanel
    };

    return (
      <div className="u_paddingLeftRight izenda-ReportConfiguration">
        {isNil(store.tenantId) && (
          <Panel header={header} collapsible expanedOption>
            <p>{localization.getText('SYSTEM_CONFIGURATION_REPORT_LABEL_VERSION_HISTORY')}</p>

            <div className="checkbox">
              <label>
                <Input
                  type="checkbox"
                  checked={model.enforceVersionHistory}
                  onChange={props.setEnforceVersionHistory}
                />
                {localization.getText('SYSTEM_CONFIGURATION_REPORT_ENFORCE_VERSION_HISTORY')}
              </label>
            </div>

            {model.enforceVersionHistory && <ReportVersionStorage {...props} />}
          </Panel>
        )}

        <Panel header={defaultImageHeader} collapsible expanedOption>
          <div className="u_marginLeft">
            <span>{localization.getText('SYSTEM_CONFIGURATION_REPORT_RELATIVE_PATH_OR_URL')}</span>
            <div className="u_inlineBlock u_marginLeft">
              <Input
                type="text"
                maxLength={256}
                value={model.defaultImageUrl.value}
                onChange={props.defaultImageUrlHander}
              />
            </div>
          </div>
        </Panel>

        {store.doesNeedToValidateGlobalAndLocalNames() && <GlobalAndLocalNames store={store} />}
        {<DefaultColorTheme store={store} />}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/SystemConfiguration/Report/Izenda.ReportConfigurationContent.js